
import postcssStyledJsxUrlLoader_0 from '../../images/edge-texture.svg';
import css from 'styled-jsx/css';

const styles = css.global`/* @styled-jsx=global */

.hero-wrapper {
  &--lightgray {
    background-color: $stone;
  }
  &--teal {
    background-color: $aqua;
  }
  &--white {
    background-color: $white;
  }

  &.hero--bottom-texture {
    position: relative;

    &:after {
      content: '';
      position: absolute;
      background-color: inherit;
      height: 18px;
      left: -3vw;
      mask-image: url("${postcssStyledJsxUrlLoader_0}");
      mask-repeat: repeat no-repeat;
      width: 106vw;
      z-index: 1;
      bottom: -18px;
    }
  }

  .hero {
    @include media-query(mobile) {
      grid-row-gap: 20px;
    }
  }

  .left-align {
    .watch-demo-wrapper {
      @include media-query(tablet) {
        justify-content: flex-start;
      }
    }
  }

  .avatars {
    position: relative;
    margin-top: 55px;

    .avatar {
      margin: 15px 0;
      width: 35px;
      height: 35px;
      border-radius: 100%;
      border: 2px solid #fff;
      overflow: hidden;
      position: relative;
      display: inline-block;
      right: 0;

      @for $i from 1 through 2 {
        &--#{$i} {
          right: #{$i * 10px};
        }
      }
    }

    @include media-query(tablet) {
      .avatar {
        width: 44px;
        height: 44px;

        @for $i from 1 through 2 {
          &--#{$i} {
            right: #{$i * 15px};
          }
        }
      }
    }
  }
}
`;

export default styles;